import { GridCellProps } from 'core/elements/grid/hooks/useGridRows'
import { IResourceUsage } from 'app/plugins/infrastructure/components/clusters/model'
import ResourceUsageTables from '../ResourceUsageTables'
import React from 'react'

export default function StatsCell({ item, value: usage }: GridCellProps<unknown, IResourceUsage>) {
  return <ResourceUsageTables usage={usage} />
}
